/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import {
  selectItemById,
  selectItemsIds,
  sendRequest
} from 'mt-react-common/common/reducers/_list/reducer';
import { t } from 'utils/translates';

import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';
import { connect } from 'react-redux';
import UserOutputCashAccountsNavigateItem from './UserOutputCashAccountsNavigateItem';

class UserOutputCashAccountsNavigate extends Component {
  constructor(props) {
    super(props);
    this.props.sendRequest();
  }

  render() {
    let items = null;
    if (this.props.itemsIds.length > 0) {
      items = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            <UserOutputCashAccountsNavigateItem
              key={`userOutputCashAccountsNavigateItem${itemId}`}
              reducerNameOutputCashAccounts={
                this.props.reducerNameOutputCashAccounts
              }
              reducerNameOutputCashFrom={this.props.reducerNameOutputCashFrom}
              item={this.props.selectItemById(itemId)}
            />
          ))}
          {/* {!this.props.itemsIds.includes(5) ? (
            <div className="col-sm-24 col-xs-24" style={{ paddingTop: '20px' }}>
              <div className="alert alert-warning m-b-0">
                {t(
                  'Вывод средств на Qiwi кошельки временно недоступен в связи со сбоем в работе платежной системы QIWI. Пожалуйста, воспользуйтесь альтернативным способом вывода. Приносим извинения за неудобства.'
                )}
              </div>
            </div>
          ) : null} */}
          {!this.props.itemsIds.includes(3) && false ? (
            <div className="col-sm-24 col-xs-24" style={{ paddingTop: '20px' }}>
              <div className="alert alert-warning m-b-0">
                {t(
                  'Вывод средств на Юмани кошельки временно недоступен. Пожалуйста, воспользуйтесь альтернативным способом вывода. Приносим извинения за неудобства.'
                )}
              </div>
            </div>
          ) : null}
        </React.Fragment>
      );
    } else {
      items = <div className="text-center">{t('Записи не найдены')} :-(</div>;
    }
    return (
      <React.Fragment>
        <label className="control-label" htmlFor="radio1">
          {t('Способ вывода')}
        </label>
        <div className="control-group">{items}</div>
      </React.Fragment>
    );
  }
}

UserOutputCashAccountsNavigate.propTypes = {
  reducerNameOutputCashAccounts: PropTypes.string.isRequired,
  reducerNameOutputCashFrom: PropTypes.string.isRequired,
  requestStatusData: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired
  }).isRequired,

  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  sendRequest: PropTypes.func.isRequired,
  selectItemById: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestStatusData: selectRequestStatusData(
    props.reducerNameOutputCashAccounts,
    state
  ),
  itemsIds: selectItemsIds(state, props.reducerNameOutputCashAccounts),
  selectItemById: id =>
    selectItemById(state, props.reducerNameOutputCashAccounts, id)
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(props.reducerNameOutputCashAccounts))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserOutputCashAccountsNavigate)
);



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashForm/UserOutputCashAccountsNavigate/UserOutputCashAccountsNavigate.js